import { PriorityLevel } from '@sib/api';

export const priorityColors: Record<PriorityLevel, string> = {
  [PriorityLevel.Low]: 'hsl(var(--info-subtle))',
  [PriorityLevel.Medium]: 'hsl(var(--warning-subtle))',
  [PriorityLevel.High]: 'hsl(var(--accent-pink-soft))',
};

export const priorityTagClassNames: Record<PriorityLevel, string> = {
  [PriorityLevel.Low]: 'border-info bg-info-soft text-info',
  [PriorityLevel.Medium]: 'border-warning bg-warning-subtle text-warning',
  [PriorityLevel.High]:
    'border-accent-pink bg-accent-pink-soft text-accent-pink',
};
